import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { Voucher } from '../types/voucher.type';

export type GetListVoucherParams = Partial<ApiParamsDefault>;
export type GetVoucherResponse = ApiResponsePagination<Voucher>;

export const getListVoucher = async (
  params?: GetListVoucherParams
): Promise<GetVoucherResponse> => {
  const url = 'voucher';

  return await apiClient.get(url, { params });
};

export const GET_LIST_VOUCHER_QUERY_KEY = 'list-voucher';
export function getVouchersQueryOptions(params?: GetListVoucherParams) {
  return queryOptions({
    queryKey: [GET_LIST_VOUCHER_QUERY_KEY, params],
    queryFn: () => getListVoucher(params),
  });
}
